import { conversationTimestamp } from "../ConversationList/conversationTimestamp"
import s from "./ThreadTimeDivider.module.scss"

type ThreadTimeDividerProps = {
  /** Unix ms of the message it sits above. */
  timestamp: number
}

/** When the messages below it were sent, centred above the burst. */
export function ThreadTimeDivider({ timestamp }: ThreadTimeDividerProps) {
  return (
    <time
      className={s.timeDivider}
      dateTime={new Date(timestamp).toISOString()}
    >
      {conversationTimestamp(timestamp)}
    </time>
  )
}
